import { Theme } from '@mui/material/styles'

import { TICK_PADDING } from './Checkbox'

// ----------------------------------------------------------------------
// A radio is a checkbox that happens to be round. It takes the same inset for
// the same reason and from the same constant: a radio and a checkbox in one
// form sitting on two different insets is the drift the shared value removes.
// ----------------------------------------------------------------------

export default function Radio(theme: Theme) {
  return {
    MuiRadio: {
      styleOverrides: {
        root: {
          'padding': TICK_PADDING,
          // Declared nowhere here until now, so MUI's `action.disabled` default
          // applied and a radio that cannot be pressed measured the same
          // 1.98:1 a checkbox did. Same role, same reason, same single
          // selector — see the note in `Checkbox.tsx`.
          '&.Mui-disabled': {
            color: theme.palette.controlEdge,
          },
          'svg': {
            'fontSize': 24,
            '&[font-size=small]': {
              fontSize: 20,
            },
          },
        },
      },
    },
  }
}
